import { useContext } from "react"

import SpansContext from "./SpansContext"

export const useSpansContext = () => {
  const context = useContext(SpansContext)
  if (!context) {
    throw new Error("useSpansContext must be used within SpansProvider")
  }
  return context
}
